var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control text-right",attrs:{"type":"tel"},domProps:{"value":_vm.displayValue},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }